import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AuthPage from './pages/AuthPage';
import BrowsePage from './pages/BrowsePage';
import MySchedulePage from './pages/MySchedulePage';
import GroupsPage from './pages/GroupsPage';
import ProfilePage from './pages/ProfilePage';
import InvitePage from './pages/InvitePage';
import JoinPage from './pages/JoinPage';
import ShareTeePage from './pages/ShareTeePage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import FriendsPage from './pages/FriendsPage';
import AdminPage from './pages/AdminPage';
import HelpPage from './pages/HelpPage';
import Layout from './components/Layout';
import InstallPrompt from './components/InstallPrompt';
import NotificationPermissionPrompt from './components/NotificationPermissionPrompt';
import './index.css';

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen">Loading...</div>;
  return user ? children : <Navigate to="/auth" replace />;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/invite/:token" element={<InvitePage />} />
          <Route path="/join/:code" element={<JoinPage />} />
          <Route path="/tee/:id" element={<ShareTeePage />} />
          <Route path="/" element={<Protected><><Layout /><InstallPrompt /><NotificationPermissionPrompt /></></Protected>}>
            <Route index element={<Navigate to="/browse" replace />} />
            <Route path="browse"  element={<BrowsePage />} />
            <Route path="my"      element={<MySchedulePage />} />
            <Route path="groups"  element={<GroupsPage />} />
            <Route path="profile" element={<ProfilePage />} />
          <Route path="friends" element={<FriendsPage />} />
          <Route path="admin"   element={<AdminPage />} />
          <Route path="help"    element={<HelpPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
